'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBem = require('../../i-bem/i-bem.react');

require('./../../popup2/popup2.react.js'), (require('./../../popup2/_autoclosable/popup2_autoclosable_yes.react.js').default || require('./../../popup2/_autoclosable/popup2_autoclosable_yes.react.js')).applyDecls();
exports.default = (0, _iBem.declMod)(function (_ref) {
    var autoclosable = _ref.autoclosable,
        onOutsideClick = _ref.onOutsideClick;
    return autoclosable || onOutsideClick;
}, {
    block: 'modal',

    /**
     * @override
     */
    _isElementOutside: function _isElementOutside(element) {
        return this.domElementPopup.contains(element) && !this._contentElement.contains(element);
    }
});